import axios from "axios";
import { API_URL } from "../../const";

/*************** USERTYPE DETAILS ADD START *************** */
export const userTypeDetailsAdd = (addData: any) => {
  const data = {
    CreateUserTypeToken: addData,
  };
  const url = `${API_URL}CreateUserType`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** USERTYPE DETAILS ADD END *************** */

/*************** USERTYPE DETAILS UPDATE START *************** */
export const userTypeDetailsUpdate = (updateData: any) => {
  const data = {
    UpdateUserTypeToken: updateData,
  };
  const url = `${API_URL}UpdateUserType`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** USERTYPE DETAILS UPDATE END *************** */

/*************** USERTYPE DETAILS GET START *************** */
export const userTypeListGet = (listData: any) => {
  const data = {
    GetAllUserTypePaginationToken: listData,
  };
  const url = `${API_URL}GetAllUserTypeDetailsPagination`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** USERTYPE DETAILS GET END *************** */

/*************** USERTYPE DETAILS FETCH START *************** */
export const userTypeDetailsFetch = (fetchData: any) => {
  const data = {
    GetUserTypeToken: fetchData,
  };
  const url = `${API_URL}FetchUserTypeDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** USERTYPE DETAILS FETCH END *************** */

/*************** USERTYPE DETAILS DELETE START *************** */
export const userTypeDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteUserTypeToken: deleteData,
  };
  const url = `${API_URL}DeleteUserType`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** USERTYPE DETAILS DELETE END *************** */
